document.addEventListener("DOMContentLoaded", function () {
    const rootContainer = document.querySelector('.rich-text__container');
    const allTextNodes = rootContainer.querySelectorAll('h1,h2,h3,h4,p');

    allTextNodes.forEach(el => {
        if (/®/.test(el.innerHTML)) {
            el.innerHTML = el.innerHTML.replace(/®/g, '<span class="trademark">®</span>');
        }
    });
});